export type MonthFormat = 'MMM' | 'MMMM' | 'MMMMM';

export type FormatDateValueType = Date | number | string;

export type FormatName =
  | 'numeric'
  | 'numericWithTime'
  | 'time'
  | 'timeWithSeconds'
  | 'short'
  | 'shortWithYear'
  | 'long'
  | 'longWithYear';
  // | 'just',

export enum DatetimeFormatType {
  TIME = 'time',                         // 15:00
  TIME_WITH_SECONDS = 'timeWithSeconds', // 15:00:00
  NUMERIC = 'numeric',                   // 01.01.2000
  NUMERIC_WITH_TIME = 'numericWithTime', // 01.01.2000, 15:00.
  SHORT = 'short',                       // Текущий год - 1 января. Год, отличный от текущего - 1 января 2000.
  LONG = 'long',                         // Текущий год - 1 января, 15:00. Год, отличный от текущего - 1 января 2000, 15:00.
  FRIENDLY = 'friendly',                 // Сегодня в. Завтра в. Вчера в. 1 января 2000, 15:00
}

export enum DatetimeMonthFormat {
  FULL = 'full',            // 1 января
  SHORT = 'short',          // 1 янв
  ONE_LETTER = 'oneLetter', // 1 я
}

export enum TypeOfDate {
  HUMAN_DATE = 'humanDate', // Текущий день - 1 января. В 00:00 2 января наступает "Завтра"
  MATCH_DATE = 'matchDate', // Текущий день - 1 января. В 6:00 утра 2 января наступает "Завтра"
}

export enum FriendlyFormatName {
  YESTERDAY = 'yesterday',
  TODAY = 'today',
  TOMORROW = 'tomorrow',
}

export enum FriendlyAdditions {
  DEFAULT = 'default',
  WITH_TIME = 'withTime',
}

type DatetimeValueType = {
  date: FormatDateValueType;
  format: DatetimeFormatType;
  monthFormat?: DatetimeMonthFormat;
  typeOfDate?: TypeOfDate;
  friendlyFormat?: FriendlyAdditions;
};

export type i18nextFormatValueType = DatetimeValueType; // | AmountValueType

export type FormatType = 'datetime';
